import ReactGA from 'react-ga'
import scrollToElement from 'scroll-to-element'
import { createEvent } from '../containers/UserEvents/actions'
import { getPermanentId } from '../helpers'
import { ANALYTICS_ID } from '../constants/keys'

/**
 * The function `postPageViewEvent` dispatches an event to track page views.
 * It wraps the `createEvent` module to post to BigQuery events under the `pageviews` category
 * for this application (`ca` aka agent ai)
 *
 * @param {*} _store  - An object that represents the Redux store. It is typically
 * used to dispatch actions and manage the application state.
 */
const postPageViewEvent = (_store) => {
  _store.dispatch(createEvent({ category: 'pageviews' }))
}

/**
 * The function sets fields on the page and updates Google Analytics with the current phone ID,
 * hostname, and permanent ID.
 *
 * @param {*} _store - Reference to an object that represents the state of the application ie redux
 * @param {typeof ReactGA} _ga - Referrence to an instance of Google Analytics. It is used
 * to track and analyze user behavior on a website.
 */
const setFieldsOnPageUpdate = (_store, _ga) => {
  const { currentPhoneId } = _store.getState().devicebits

  _ga.set({
    dimension1: window.location.hostname,
    dimension2: currentPhoneId,
    dimension3: getPermanentId()
  })

  _ga.pageview(window.location.href)
}

/**
 * Handle all that needs to happen in a page view event.
 *
 * responsible for updating the route, scrolling to the top of the
 * page, setting fields on the page, and posting a page view event.
 *
 * @param {*} _store - Reference to the application's state management system ie redux store
 * @param {typeof ReactGA} _ga - Reference to the Google Analytics tracking object.
 */
const handleRouteUpdate = (_store, _ga) => {
  scrollToElement('body', { duration: 200 })
  setFieldsOnPageUpdate(_store, _ga)
  postPageViewEvent(_store)
}

/**
 *  The function initializes page analytics using the provided analytics ID.
 * @param {typeof ReactGA} _ga - Reference to the Google Analytics tracking object.
 * @param {string=ANALYTICS_ID} analyticsId - The ID of the Google Analytics property to initialize.
 * it will default to the value of `ANALYTICS_ID`.
 */
const initializePageAnalytics = (_ga, analyticsId = ANALYTICS_ID) => {
  _ga.initialize(analyticsId)
}

/**
 * Declare and export ga instance to pass as arg to above functions after initializing sequentially
 */
const ga = ReactGA

export { handleRouteUpdate, initializePageAnalytics, ga }
